<template>
  <v-card class="my-5" elevation="3" outlined>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-data-table :items="rankedAccounts" :headers="headers" hide-default-footer>
          <template v-slot:item.identifier="{ item }">
            <p class="my-0">
              <v-avatar size="35" style="border: 2px solid #c9c9c9 !important">
                <v-img contain class="d-flex justify-center align-center "
                       :src="item.brokerAccount.user.imageUrl !== null? item.brokerAccount.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"/>
              </v-avatar>
              {{ `${item.brokerAccount.identifier} | ${item.brokerAccount.broker.name}` }}
            </p>
          </template>
          <template v-slot:item.profit="{ item }">
            <p class="my-0" :style="`color: ${getPnLColor(item.profit)}`">{{ (item.profit > 0)? `+${item.profit}` : item.profit }}</p>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-chip v-if="myInvests.findIndex((invest => invest.rankedAccount.id === item.id)) !== -1">{{ $t('actions.invested') }} <v-icon class="ml-2" small>fa-square-check</v-icon></v-chip>
            <v-btn v-else @click="investInAccount(item)">{{ $t('actions.invest') }} <v-icon class="ml-2" small>fa-circle-dollar-to-slot</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/leaderboard';

export default {
  name: "LeaderboardList",
  props: {
    rankedAccounts: Array,
    myInvests: Array,
  },
  data() {
    return {
      headers: [
        { text: this.$t('headers.identifier'), align: 'left', value: 'identifier', sortable: false },
        { text: this.$t('headers.swisetRatio'), align: 'center', value: 'swisetRatio', sortable: false },
        { text: this.$t('headers.PnL'), align: 'center', value: 'profit', sortable: false },
        //{ text: this.$t('headers.performanceChart'), align: 'left', value: 'performanceChart', sortable: false },
        { text: this.$t('headers.trades'), align: 'center', value: 'trades', sortable: false },
        { text: this.$t('headers.investors'), align: 'center', value: 'investors', sortable: false },
        { text: this.$t('headers.actions'), align: 'center', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    getPnLColor(profit) {
      return (profit > 0) ? '#00a575' : '#ff6b55';
    },
    investInAccount(rankedAccount) {
      Repository.voteAsInterestedInvestor(rankedAccount.id).then((response) => {
        if(response.status < 400)
          alert('Your vote was successfully submitted to invest in this account');
      })
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "headers": {
      "identifier": "Account",
      "swisetRatio": "Swiset Ratio",
      "PnL": "PnL",
      "performanceChart": "Performance",
      "trades": "# Trades",
      "investors": "Investors",
      "actions": "Actions"
    },
    "actions": {
      "invest": "Invest",
      "invested": "Interested"
    }
  },
  "es": {
    "headers": {
      "identifier": "Cuenta",
      "swisetRatio": "Ratio Swiset",
      "PnL": "Rentabilidad",
      "performanceChart": "Rendimiento",
      "trades": "# Trades",
      "investors": "Inversionistas",
      "actions": "Acciones"
    },
    "actions": {
      "invest": "Invertir",
      "invested": "Interesado"
    }
  }
}
</i18n>
